import { ChevronRight } from 'lucide-react'
import './rules.css'

/**
 * "See all rules" — one component, so every surface that offers it offers it identically.
 *
 * Label left, chevron right, muted, on a hairline. It is navigation, and it must never read as
 * the option beside a dismissal: a centred muted "Close" next to a centred muted "See all rules"
 * made two very different things look like a choice between equals.
 *
 * No colour of its own, on purpose. Where a sheet has a primary action ("Play for Gameweek 7")
 * that action keeps all the contrast; and cyan in particular belongs to active chip states, never
 * to a link.
 */
export default function SeeAllRulesRow({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className="see-all-rules" onClick={onClick}>
      <span>See all rules</span>
      <ChevronRight className="see-all-rules__chevron" aria-hidden="true" />
    </button>
  )
}
